import { Button, HStack, Spacer, Text, Textarea, useToast, VStack } from '@chakra-ui/react';
import { useDeleteCPFSMutation } from '@partiu/api/dashboard/hooks.ts';
import { ICreateSubscriptionData } from '@partiu/api/dashboard/types.ts';
import { FaFile } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa6';
import { useState } from 'react';
import { AddModalProps } from '../../types';
import { loadCSV } from '@partiu/ui/utils.ts';
import validateCNPJ from '../../utils/CNPJValidator.ts';
import validateCPF from '../../utils/CPFValidator.ts';

function sanitizeCPFandCNPJText(text: string): string[] {
  const cpfAndCnpjArray = text.split('\n');

  const filteredCPFCNPJArray = cpfAndCnpjArray.filter((entry) => {
    const numericValue = entry.replace(/\D/g, '');
    return numericValue.trim() !== '' && (validateCPF(numericValue) || validateCNPJ(numericValue));
  });

  const sanitizedCPFCNPJArray = filteredCPFCNPJArray.map((entry) => {
    const numericValue = entry.replace(/\D/g, '');
    if (numericValue.length === 11) {
      return numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      return numericValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  });

  return [...new Set(sanitizedCPFCNPJArray)];
}

export function CPFFormRemove({ onClose = () => {}, options }: AddModalProps<ICreateSubscriptionData>) {
  const toast = useToast();
  const [cpfs, setCPFS] = useState('');
  const [sanitizedCPFS, setSanitizedCPFS] = useState<string[]>([]);
  const deleteCPFSMutation = useDeleteCPFSMutation(options);

  const setCPFandCNPJData = (text: string) => {
    setCPFS(text);
    const sanitizedCPFsList = sanitizeCPFandCNPJText(text);
    setSanitizedCPFS(sanitizedCPFsList);
  };

  return (
    <VStack spacing={5} align={'flex-start'}>
      <Text marginTop={'-25px'} fontSize={'10pt'} color={'#a9a9a9'}>
        Insira um CPF/CNPJ por linha
      </Text>
      <Textarea
        value={cpfs}
        onChange={(e) => setCPFandCNPJData(e.target.value)}
        minHeight={'150px'}
        placeholder={'Digite aqui os CPFs / CNPJs'}
      />
      <Text fontSize={12} marginTop={'-15px'} color={'#a5a5a5'}>
        {sanitizedCPFS.length} CPFs/CNPJs válidos e distintos encontrados.
      </Text>
      <HStack width={'100%'}>
        <Button
          isLoading={deleteCPFSMutation.isLoading}
          leftIcon={<FaFile />}
          variant={'outline'}
          colorScheme={'blue'}
          onClick={() =>
            loadCSV((code: string) => {
              setCPFandCNPJData(code);
              toast({
                title: 'CSV Carregado.',
                description: `${sanitizedCPFS.length} CPFs/CNPJs carregados com sucesso.`,
              });
            })
          }
        >
          Carregar CSV
        </Button>
        <Spacer />
        <Button isLoading={deleteCPFSMutation.isLoading} variant="ghost" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          isDisabled={cpfs.split('\n').length === 0}
          leftIcon={<FaPlus />}
          isLoading={deleteCPFSMutation.isLoading}
          variant={'solid'}
          onClick={() =>
            deleteCPFSMutation.mutate({
              cpfs: sanitizedCPFS
            })
          }
          colorScheme={'red'}
        >
          Deletar
        </Button>
      </HStack>
    </VStack>
  );
}
